(function () {
  const STORAGE_KEY = 'poubel_configurator_popup_hidden_until';
  const HOURS_MS = 24 * 60 * 60 * 1000;

  function shouldShowPopup() {
    const hiddenUntil = localStorage.getItem(STORAGE_KEY);
    if (!hiddenUntil) return true;
    return Date.now() > Number(hiddenUntil);
  }

  function hidePopupFor24Hours() {
    localStorage.setItem(STORAGE_KEY, String(Date.now() + HOURS_MS));
  }

  function closePopup(popup) {
    popup.classList.remove('is-active');
    popup.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  function openConfigurator() {
    if (typeof window.openPoubelConfigurator === 'function') {
      window.openPoubelConfigurator();
      return;
    }
    document.querySelector('.create-your-own-btn-pdp')?.click();
  }

  function initConfiguratorPopup() {
    const popup = document.querySelector('[data-configurator-popup]');
    if (!popup || !shouldShowPopup()) return;

    const closeBtn = popup.querySelector('[data-configurator-popup-close]');
    const overlay = popup.querySelector('[data-configurator-popup-overlay]');
    const container = popup.querySelector('.configurator-popup__container');
    const ctaBtn = popup.querySelector('[data-configurator-popup-cta]');

    function dismissPopup(openConfiguratorAfter) {
      hidePopupFor24Hours();
      closePopup(popup);
      if (openConfiguratorAfter) openConfigurator();
    }

    popup.classList.add('is-active');
    popup.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';

    closeBtn?.addEventListener('click', (event) => {
      event.stopPropagation();
      dismissPopup(false);
    });

    overlay?.addEventListener('click', () => dismissPopup(false));

    container?.addEventListener('click', (event) => {
      event.stopPropagation();
    });

    ctaBtn?.addEventListener('click', (event) => {
      event.stopPropagation();
      dismissPopup(true);
    });

    document.addEventListener('keydown', function onEscape(event) {
      if (event.key !== 'Escape' || !popup.classList.contains('is-active')) return;
      dismissPopup(false);
      document.removeEventListener('keydown', onEscape);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initConfiguratorPopup);
  } else {
    initConfiguratorPopup();
  }
})();
